"use strict";
var buttons = document.querySelectorAll(".gallery__nav-link");
buttons.forEach(function(button) {
    button.addEventListener("click", function() {
        buttons.forEach(function(b) {
            return b.classList.remove("active");
        });
        button.classList.add("active");
    });
});

//# sourceMappingURL=index.d79a59f3.js.map
